export default {};
throw new Error(`Could not resolve "matter-js" imported by "@appletosolutions/reactbits". Is it installed?`)